import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { logger } from '@/features/help/utils/logger';
import { Button } from '@/features/ui/components/Button';
import { ShieldCheck } from 'lucide-react';

export const EmailVerificationSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    logger.debug(
      'EmailVerificationSuccess',
      'Page loaded. Email should have been verified by AuthActionHandlerPage.'
    );
  }, []);

  const renderIcon = () => {
    return <ShieldCheck className="mx-auto h-16 w-16 text-green-500" />;
  };

  return (
    <div className="min-h-screen bg-gray-900 flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8 text-white">
      <div className="max-w-md w-full space-y-8 bg-gray-800 p-10 rounded-lg shadow-xl text-center">
        {renderIcon()}

        <h2 className="mt-6 text-3xl font-extrabold">Email Verified!</h2>

        <p className="mt-2 text-gray-300">
          Your email address has been successfully verified. You can now proceed to login.
        </p>

        <div className="mt-8">
          <Button
            onClick={() => navigate('/login')}
            className="w-full bg-blue-500 hover:bg-blue-600"
          >
            Proceed to Login
          </Button>
        </div>
      </div>
    </div>
  );
};
